import React, {ReactNode} from 'react';
import SelectionInput from "./SelectionInput";
import NumberInput from "./NumberInput";
import ButtonActions from "../../Actions/ButtonActions";

type SelectionUnitInputProps = {
    label?: string,
    actions?: ReactNode
    selectionName: string,
    numberName: string,
    unitName: string,
    selectionOptions: Option[]
    unitOptions: Option[]
}

function SelectionUnitInput(props: SelectionUnitInputProps) {
    const {unitName, numberName, selectionOptions, unitOptions, selectionName, label, actions} = props

    return (
        <div className={"molekuls-two-selectionunitinput"}>
            <div className="label-bar">
                {label ? <label htmlFor={selectionName}>{label}</label> : null}
                {actions ? <ButtonActions>{actions}</ButtonActions> : null}
            </div>
            <div className={"inputs"}>
                <SelectionInput name={selectionName} options={selectionOptions}/>
                <NumberInput name={numberName}/>
                <SelectionInput name={unitName} options={unitOptions}/>
            </div>
        </div>
    );
}

export default SelectionUnitInput;
